import { Breakpoint, useCheckBreakpoint } from '~/utils'
import useGetMenuCategories from '~/menu/hooks/useGetCategories'

import MegaMenuDesktop from './MegaMenuDesktop'
import MenuBottomBar from './MenuBottomBar'
import MenuMobilePanel from './MenuMobilePanel'

export default function MenuContent(): React.ReactElement {
  const isMobile = useCheckBreakpoint({ lt: Breakpoint.MD })
  const categories = useGetMenuCategories()

  if (isMobile) return <MenuMobilePanel categories={categories} />

  return (
    <div className="relative">
      {/* Blobs get their own clipping layer so the curriculum dropdown can overflow the panel */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <span className="absolute -left-20 -top-3 h-120 w-120 rounded-full bg-menu-blob" />
        <span className="absolute -right-10 top-34 h-80 w-80 rounded-full bg-menu-blob" />
      </div>
      <MegaMenuDesktop categories={categories} />
      <MenuBottomBar />
    </div>
  )
}
